import { render } from "./Tetris.vue?vue&type=template&id=0f942794&ts=true"
import script from "./Tetris.vue?vue&type=script&lang=ts"
export * from "./Tetris.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/beatout-frontend/beatout-frontend/beatout/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__